var LoggerMiddleware, RedrawMiddleware, Reducer, applyMiddleware, createStore, ref;

ref = require('redux'), createStore = ref.createStore, applyMiddleware = ref.applyMiddleware;

Reducer = require('./Reducer');

LoggerMiddleware = require('./LoggerMiddleware');

RedrawMiddleware = require('./RedrawMiddleware');

module.exports = function(initialState) {
  return createStore(Reducer, initialState, applyMiddleware(LoggerMiddleware, RedrawMiddleware));
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2FwcC9zcmMvc3RhdGUvU3RvcmVGYWN0b3J5LmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9hcHAvc3JjL3N0YXRlL1N0b3JlRmFjdG9yeS5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxNQUFtQyxPQUFBLENBQVEsT0FBUixDQUFuQyxFQUFFLDZCQUFGLEVBQWU7O0FBRWYsT0FBQSxHQUFhLE9BQUEsQ0FBUSxXQUFSOztBQUNiLGdCQUFBLEdBQW9CLE9BQUEsQ0FBUSxvQkFBUjs7QUFDcEIsZ0JBQUEsR0FBb0IsT0FBQSxDQUFRLG9CQUFSOztBQUVwQixNQUFNLENBQUMsT0FBUCxHQUFpQixTQUFDLFlBQUQ7U0FDaEIsV0FBQSxDQUNDLE9BREQsRUFFQyxZQUZELEVBR0MsZUFBQSxDQUFnQixnQkFBaEIsRUFBa0MsZ0JBQWxDLENBSEQ7QUFEZ0IifQ==
